import { BaseEntityInfoUtils, EntityInfo } from '@record-it-npm/synchro-common';
import { AppCommonSynchronizationEnvironmentTypes } from '../../../AppCommonSynchronizationEnvironment';
import { EntityName } from '../../../EntityName';
import { CreateEntityInfoOptions } from '../../base/CreateEntityInfoOptions';
import { UserGroupSubEntityInfoUtils } from '../../base/UserGroupSubEntityInfoUtils';
import { TimeTrackingConfigurationDto } from './TimeTrackingConfigurationDto';
export function createTimeTrackingConfigurationEntityInfo<TEntity extends TimeTrackingConfigurationDto>(options: CreateEntityInfoOptions<TimeTrackingConfigurationDto, TEntity>): EntityInfo<AppCommonSynchronizationEnvironmentTypes, EntityName.TimeTrackingConfiguration, TEntity> {
  return {
    entityName: EntityName.TimeTrackingConfiguration,
    synchronizeRelativeTo: [],
    trackGlobalRevision: true,
    fieldInfos: BaseEntityInfoUtils.createFieldInfos<AppCommonSynchronizationEnvironmentTypes, TimeTrackingConfigurationDto, TEntity>({
      ...UserGroupSubEntityInfoUtils.createBaseFieldInfos(),
      maxWorkHoursPerDay: {
        name: 'maxWorkHoursPerDay',
        defaultValue: 10
      },
      name: {
        name: 'name',
        defaultValue: ''
      }
    }, options.additionalFieldInfos)
  };
}